<template>
    <v-select
        v-model="selectedStatus"
        :loading="loading"
        :disabled="loading"
        :items="statuses"
        append-icon="mdi-close"
        density="compact"
        hide-details
        return-object
        class="ma-0"
        @update:model-value="save"
        @click:append="close"
    />
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class OrderDetailsEditReservationStatus extends Vue {
        @Prop({required: true}) status
        @Prop({required: true}) orderId
        @Prop({default: false, type: Boolean}) loading

        selectedStatus = null
        actualStatuses = []

        @Emit()
        save() {
            if (this.selectedStatus.value !== this.status) return this.selectedStatus.value
        }

        @Emit()
        close() {}

        mounted() {
            this.selectedStatus = {value: this.status, title: this.$t(`order_statuses.${this.status}`)}
            this.actualStatuses = [this.status]
            this.load()
        }

        async load() {
            try {
                const {statuses} = await this.$api.currentOrderStatuses.get({orderId: this.orderId})

                statuses.forEach(item => {
                    if (item !== this.actualStatuses[0]) this.actualStatuses.push(item)
                })
                // eslint-disable-next-line no-empty
            } catch (e) {}
        }

        get statuses() {
            return this.actualStatuses.map(value => ({value, title: this.$t(`order_statuses.${value}`)}))
        }
    }

    export default OrderDetailsEditReservationStatus
</script>
